import { render, staticRenderFns } from "./DeliverableUploadWrapper.vue?vue&type=template&id=3c47d94e&scoped=true"
import script from "./DeliverableUploadWrapper.vue?vue&type=script&lang=js"
export * from "./DeliverableUploadWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c47d94e",
  null
  
)

export default component.exports